import { ChangePasswordInterface } from "../../domain/interface/change_password_interface";
import { AuthRepository } from "../../domain/repository/auth_repository";
import { AuthenticationLocalService } from "../data_source/local/authentication_local_service";
import { AuthenticationApiService } from "../data_source/remote/authentication_api_service";

export class AuthRepositoryImpl implements AuthRepository {
    private authApiService: AuthenticationApiService;
    private authLocalService: AuthenticationLocalService;

    constructor() {
        this.authApiService = new AuthenticationApiService();
        this.authLocalService = new AuthenticationLocalService();
    }

    async logout(): Promise<void> {
        const response = await this.authApiService.logout();
        if (response.status === 200) {
            this.authLocalService.removeAccessToken();
            this.authLocalService.removeRefreshToken();
        }
    }

    async deleteAccount(): Promise<void> {
        const response = await this.authApiService.deleteAccount();
        if (response.status === 200) {
            this.authLocalService.removeAccessToken();
            this.authLocalService.removeRefreshToken();
        }
    }

    async changePassword({ oldPassword, newPassword }: ChangePasswordInterface): Promise<void> {
        await this.authApiService.changePassword(oldPassword, newPassword);
    }
}